<!--
 * @Author: Src
 * @Date: 2024-12-17 18:23:53
 * @LastEditTime: 2024-12-25 17:10:30
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/shoplist.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div class="wrap">
        <TopTitle>
            <template #center>
                <div>门店列表</div>
            </template>
            <template #right>
                <el-button type="text" @click="addShop">添加门店</el-button>
            </template>
        </TopTitle>
        <BooyComponent>
            <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto" :infinite-scroll-immediate="false"
                :infinite-scroll-distance="100" :infinite-scroll-delay="1000">
                <li v-for="i in list" class="infinite-list-item" :key="i.id" @click="goDetail(i.id)">
                    <div class="shop-item">
                        <div class="shop-item-title">
                            <span>门店信息</span>
                        </div>
                        <div class="shop-item-content">
                            <div class="shop-item-content-item">
                                <div class="shop-item-content-item-label">门店名称：</div>
                                <div class="shop-item-content-item-value">{{ i.shop_name }}</div>
                            </div>
                            <div class="shop-item-content-item">
                                <div class="shop-item-content-item-label">品牌：</div>
                                <div class="shop-item-content-item-value">{{ i.ka_name }}</div>
                            </div>
                            <div class="shop-item-content-item">
                                <div class="shop-item-content-item-label">城市：</div>
                                <div class="shop-item-content-item-value">{{ i.cityName }}</div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </BooyComponent>
    </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import TopTitle from '@/components/topTitle.vue';
import BooyComponent from '@/components/booyComponent.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
@Component({
    components: {
        TopTitle,
        BooyComponent,
    },
})
export default class ShopList extends Vue {


    @lazyInject(ShopService)
    shopService!: ShopService;

    count = 1;

    total = 0;


    list: any = []


    load() {
        console.log(this.count);
        if (this.count * 10 > this.total) {
            return;
        } else {
            this.count++;
            this.getList();
        }

    }

    goDetail(id: number) {
        this.$router.push(`/shop/detail/${id}`);
    }

    async getList() {
        try {
            const _d = {
                page: this.count,
                pageSize: 10,
                ka_id: localStorage.getItem('brandcode') as string
            }
            const result = await this.shopService.getShopList(_d);
            if (result) {
                this.list = [...this.list, ...result.list];
                this.total = result.total;
            }
        } catch (error) {
            console.log(error);
        }
    }
    addShop() {
        this.$router.push('/shop/add');
    }

    mounted() {
        this.getList();
    }


}
</script>
<style lang="scss" scoped>
.shop-item {
    padding: 10px;
    border-bottom: 1px solid #ccc;

    .shop-item-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .shop-item-content {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .shop-item-content-item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .shop-item-content-item-label {
            font-size: 14px;
            color: #666;
        }

        .shop-item-content-item-value {
            font-size: 14px;
            color: #333;
        }
    }
}
</style>
